import React, { useState } from 'react';
import { getScoreColor } from '../utils/seoAnalyzer';
import './SEOScore.css';

const SEOScore = ({ score, grade, issues = [], recommendations = [], compact = false, showDetails = false }) => {
  const [expanded, setExpanded] = useState(showDetails);

  if (compact) {
    return (
      <div className="seo-score-compact">
        <div 
          className="score-badge"
          style={{ backgroundColor: getScoreColor(score) }}
          title={`SEO Score: ${score}/100 (Grade ${grade})`}
        >
          <span className="score-value">{score}</span>
          <span className="score-grade">{grade}</span>
        </div>
      </div>
    );
  }

  const positiveIssues = issues.filter(issue => issue.type === 'positive');
  const warningIssues = issues.filter(issue => issue.type === 'warning');
  const errorIssues = issues.filter(issue => issue.type === 'error');
  const infoIssues = issues.filter(issue => issue.type === 'info');

  return (
    <div className="seo-score">
      <div className="score-header" onClick={() => setExpanded(!expanded)}>
        <div className="score-main">
          <div 
            className="score-circle"
            style={{ borderColor: getScoreColor(score) }}
          >
            <span className="score-number">{score}</span>
            <span className="score-max">/100</span>
          </div>
          <div className="score-info">
            <div className="score-grade-large" style={{ color: getScoreColor(score) }}>
              Grade {grade}
            </div>
            <div className="score-summary">
              {errorIssues.length > 0 && (
                <span className="issue-count error">{errorIssues.length} errors</span>
              )}
              {warningIssues.length > 0 && (
                <span className="issue-count warning">{warningIssues.length} warnings</span>
              )}
              {positiveIssues.length > 0 && (
                <span className="issue-count positive">{positiveIssues.length} good</span>
              )}
            </div>
          </div>
        </div>
        <div className="expand-indicator">
          <span className={`expand-arrow ${expanded ? 'expanded' : ''}`}>▼</span>
        </div>
      </div>

      {expanded && (
        <div className="score-details">
          {errorIssues.length > 0 && (
            <div className="issues-section">
              <h4 className="issues-title error">🚨 Critical Issues</h4>
              <ul className="issues-list">
                {errorIssues.map((issue, index) => (
                  <li key={index} className="issue-item error">
                    <span className="issue-message">{issue.message}</span>
                    <span className="issue-impact">-{issue.impact} pts</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {warningIssues.length > 0 && (
            <div className="issues-section">
              <h4 className="issues-title warning">⚠️ Warnings</h4>
              <ul className="issues-list">
                {warningIssues.map((issue, index) => (
                  <li key={index} className="issue-item warning">
                    <span className="issue-message">{issue.message}</span>
                    <span className="issue-impact">-{issue.impact} pts</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {positiveIssues.length > 0 && (
            <div className="issues-section">
              <h4 className="issues-title positive">✅ Good Practices</h4>
              <ul className="issues-list">
                {positiveIssues.map((issue, index) => (
                  <li key={index} className="issue-item positive">
                    <span className="issue-message">{issue.message}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {infoIssues.length > 0 && (
            <div className="issues-section">
              <h4 className="issues-title info">ℹ️ Information</h4>
              <ul className="issues-list">
                {infoIssues.map((issue, index) => (
                  <li key={index} className="issue-item info">
                    <span className="issue-message">{issue.message}</span>
                    {issue.impact > 0 && <span className="issue-impact">-{issue.impact} pts</span>}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {recommendations.length > 0 && (
            <div className="recommendations-section">
              <h4 className="recommendations-title">💡 Recommendations</h4>
              <ul className="recommendations-list">
                {recommendations.map((rec, index) => (
                  <li key={index} className="recommendation-item">
                    {rec}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SEOScore; 